import cs from "../components/Clinic/common/chat.module.css";

/** http://, https:// и www.… */
const URL_RE =
  /\b((?:https?:\/\/|www\.)[^\s<>"'`]+[^\s<>"'`.,:;!?)\]])/gi;

function normalizeHref(raw) {
  const url = String(raw || "").trim();
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (/^www\./i.test(url)) return `https://${url}`;
  return null;
}

/**
 * Текст чата с кликабельными ссылками (http и https).
 * Используется во всех чатах клуба и в саппорте.
 */
export default function LinkifiedChatText({ text, className }) {
  const source = String(text || "");
  const nodes = [];
  let last = 0;
  let match;
  const re = new RegExp(URL_RE.source, URL_RE.flags);

  while ((match = re.exec(source)) !== null) {
    const raw = match[1] || match[0];
    const start = match.index;
    if (start > last) {
      nodes.push({ type: "text", value: source.slice(last, start) });
    }
    const href = normalizeHref(raw);
    if (href) {
      nodes.push({ type: "link", value: raw, href });
    } else {
      nodes.push({ type: "text", value: raw });
    }
    last = start + raw.length;
  }
  if (last < source.length) {
    nodes.push({ type: "text", value: source.slice(last) });
  }
  if (!nodes.length) {
    nodes.push({ type: "text", value: source });
  }

  return (
    <span className={className || cs.chatBubbleText}>
      {nodes.map((node, i) => {
        if (node.type === "link") {
          return (
            <a
              key={`u-${i}`}
              href={node.href}
              target="_blank"
              rel="noopener noreferrer"
              className={cs.chatBubbleLink}
              onClick={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
            >
              {node.value}
            </a>
          );
        }
        return <span key={`t-${i}`}>{node.value}</span>;
      })}
    </span>
  );
}
